import { LpMockWidgetsWebComponent } from './component/LpMockWidgetsWebComponent';

export { LpMockWidgetsWebComponent };
